import { render, staticRenderFns } from "./carousel-images-cmp.vue?vue&type=template&id=42710bf0&scoped=true"
import script from "./carousel-images-cmp.vue?vue&type=script&lang=js"
export * from "./carousel-images-cmp.vue?vue&type=script&lang=js"
import style0 from "./carousel-images-cmp.vue?vue&type=style&index=0&id=42710bf0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42710bf0",
  null
  
)

export default component.exports